<script>
import { mapActions } from "vuex";
import VueSelectImage from "vue-select-image";
import "vue-select-image/dist/vue-select-image.css";
// step2
const image1 = "/images/pagetwo_tr/kuresel_amaclar_01_renkli.png";
const image2 = "/images/pagetwo_tr/kuresel_amaclar_02_renkli.png";
const image3 = "/images/pagetwo_tr/kuresel_amaclar_03_renkli.png";
const image4 = "/images/pagetwo_tr/kuresel_amaclar_04_renkli.png";
const image5 = "/images/pagetwo_tr/kuresel_amaclar_05_renkli.png";
const image6 = "/images/pagetwo_tr/kuresel_amaclar_06_renkli.png";
const image7 = "/images/pagetwo_tr/kuresel_amaclar_07_renkli.png";
const image8 = "/images/pagetwo_tr/kuresel_amaclar_08_renkli.png";
const image9 = "/images/pagetwo_tr/kuresel_amaclar_09_renkli.png";
const image10 = "/images/pagetwo_tr/kuresel_amaclar_10_renkli.png";
const image11 = "/images/pagetwo_tr/kuresel_amaclar_11_renkli.png";
const image12 = "/images/pagetwo_tr/kuresel_amaclar_12_renkli.png";
const image13 = "/images/pagetwo_tr/kuresel_amaclar_13_renkli.png";
const image14 = "/images/pagetwo_tr/kuresel_amaclar_14_renkli.png";
const image15 = "/images/pagetwo_tr/kuresel_amaclar_15_renkli.png";
const image16 = "/images/pagetwo_tr/kuresel_amaclar_16_renkli.png";
const image17 = "/images/pagetwo_tr/kuresel_amaclar_17_renkli.png";
// step3
//  sdg1
const sdg11 = "/images/pagethree_tr/sdg1/ska1.1.png";
const sdg12 = "/images/pagethree_tr/sdg1/ska1.2.png";
const sdg13 = "/images/pagethree_tr/sdg1/ska1.3.png";
const sdg14 = "/images/pagethree_tr/sdg1/ska1.4.png";
const sdg15 = "/images/pagethree_tr/sdg1/ska1.5.png";
const sdg1a = "/images/pagethree_tr/sdg1/ska1.a.png";
const sdg1b = "/images/pagethree_tr/sdg1/ska1.b.png";
//  sdg2
const sdg21 = "/images/pagethree_tr/sdg2/ska2.1.png";
const sdg22 = "/images/pagethree_tr/sdg2/ska2.2.png";
const sdg23 = "/images/pagethree_tr/sdg2/ska2.3.png";
const sdg24 = "/images/pagethree_tr/sdg2/ska2.4.png";
const sdg25 = "/images/pagethree_tr/sdg2/ska2.5.png";
const sdg2a = "/images/pagethree_tr/sdg2/ska2.a.png";
const sdg2b = "/images/pagethree_tr/sdg2/ska2.b.png";
const sdg2c = "/images/pagethree_tr/sdg2/ska2.c.png";
//  sdg3
const sdg31 = "/images/pagethree_tr/sdg3/ska3.1.png";
const sdg32 = "/images/pagethree_tr/sdg3/ska3.2.png";
const sdg33 = "/images/pagethree_tr/sdg3/ska3.3.png";
const sdg34 = "/images/pagethree_tr/sdg3/ska3.4.png";
const sdg35 = "/images/pagethree_tr/sdg3/ska3.5.png";
const sdg36 = "/images/pagethree_tr/sdg3/ska3.6.png";
const sdg37 = "/images/pagethree_tr/sdg3/ska3.7.png";
const sdg38 = "/images/pagethree_tr/sdg3/ska3.8.png";
const sdg39 = "/images/pagethree_tr/sdg3/ska3.9.png";
const sdg3a = "/images/pagethree_tr/sdg3/ska3.a.png";
const sdg3b = "/images/pagethree_tr/sdg3/ska3.b.png";
const sdg3c = "/images/pagethree_tr/sdg3/ska3.c.png";
const sdg3d = "/images/pagethree_tr/sdg3/ska3.d.png";
//  sdg4
const sdg41 = "/images/pagethree_tr/sdg4/ska4.1.png";
const sdg42 = "/images/pagethree_tr/sdg4/ska4.2.png";
const sdg43 = "/images/pagethree_tr/sdg4/ska4.3.png";
const sdg44 = "/images/pagethree_tr/sdg4/ska4.4.png";
const sdg45 = "/images/pagethree_tr/sdg4/ska4.5.png";
const sdg46 = "/images/pagethree_tr/sdg4/ska4.6.png";
const sdg47 = "/images/pagethree_tr/sdg4/ska4.7.png";
const sdg4a = "/images/pagethree_tr/sdg4/ska4.a.png";
const sdg4b = "/images/pagethree_tr/sdg4/ska4.b.png";
const sdg4c = "/images/pagethree_tr/sdg4/ska4.c.png";
//  sdg5
const sdg51 = "/images/pagethree_tr/sdg5/ska5.1.png";
const sdg52 = "/images/pagethree_tr/sdg5/ska5.2.png";
const sdg53 = "/images/pagethree_tr/sdg5/ska5.3.png";
const sdg54 = "/images/pagethree_tr/sdg5/ska5.4.png";
const sdg55 = "/images/pagethree_tr/sdg5/ska5.5.png";
const sdg56 = "/images/pagethree_tr/sdg5/ska5.6.png";
const sdg5a = "/images/pagethree_tr/sdg5/ska5.a.png";
const sdg5b = "/images/pagethree_tr/sdg5/ska5.b.png";
const sdg5c = "/images/pagethree_tr/sdg5/ska5.c.png";
//  sdg6
const sdg61 = "/images/pagethree_tr/sdg6/ska6.1.png";
const sdg62 = "/images/pagethree_tr/sdg6/ska6.2.png";
const sdg63 = "/images/pagethree_tr/sdg6/ska6.3.png";
const sdg64 = "/images/pagethree_tr/sdg6/ska6.4.png";
const sdg65 = "/images/pagethree_tr/sdg6/ska6.5.png";
const sdg66 = "/images/pagethree_tr/sdg6/ska6.6.png";
const sdg6a = "/images/pagethree_tr/sdg6/ska6.a.png";
const sdg6b = "/images/pagethree_tr/sdg6/ska6.b.png";
//  sdg7
const sdg71 = "/images/pagethree_tr/sdg7/ska7.1.png";
const sdg72 = "/images/pagethree_tr/sdg7/ska7.2.png";
const sdg73 = "/images/pagethree_tr/sdg7/ska7.3.png";
const sdg7a = "/images/pagethree_tr/sdg7/ska7.a.png";
const sdg7b = "/images/pagethree_tr/sdg7/ska7.b.png";
//  sdg8
const sdg81 = "/images/pagethree_tr/sdg8/ska8.1.png";
const sdg82 = "/images/pagethree_tr/sdg8/ska8.2.png";
const sdg83 = "/images/pagethree_tr/sdg8/ska8.3.png";
const sdg84 = "/images/pagethree_tr/sdg8/ska8.4.png";
const sdg85 = "/images/pagethree_tr/sdg8/ska8.5.png";
const sdg86 = "/images/pagethree_tr/sdg8/ska8.6.png";
const sdg87 = "/images/pagethree_tr/sdg8/ska8.7.png";
const sdg88 = "/images/pagethree_tr/sdg8/ska8.8.png";
const sdg89 = "/images/pagethree_tr/sdg8/ska8.9.png";
const sdg810 = "/images/pagethree_tr/sdg8/ska8.10.png";
const sdg8a = "/images/pagethree_tr/sdg8/ska8.a.png";
const sdg8b = "/images/pagethree_tr/sdg8/ska8.b.png";
//  sdg9
const sdg91 = "/images/pagethree_tr/sdg9/ska9.1.png";
const sdg92 = "/images/pagethree_tr/sdg9/ska9.2.png";
const sdg93 = "/images/pagethree_tr/sdg9/ska9.3.png";
const sdg94 = "/images/pagethree_tr/sdg9/ska9.4.png";
const sdg95 = "/images/pagethree_tr/sdg9/ska9.5.png";
const sdg9a = "/images/pagethree_tr/sdg9/ska9.a.png";
const sdg9b = "/images/pagethree_tr/sdg9/ska9.b.png";
const sdg9c = "/images/pagethree_tr/sdg9/ska9.c.png";
//  sdg10
const sdg101 = "/images/pagethree_tr/sdg10/ska10.1.png";
const sdg102 = "/images/pagethree_tr/sdg10/ska10.2.png";
const sdg103 = "/images/pagethree_tr/sdg10/ska10.3.png";
const sdg104 = "/images/pagethree_tr/sdg10/ska10.4.png";
const sdg105 = "/images/pagethree_tr/sdg10/ska10.5.png";
const sdg106 = "/images/pagethree_tr/sdg10/ska10.6.png";
const sdg107 = "/images/pagethree_tr/sdg10/ska10.7.png";
const sdg10a = "/images/pagethree_tr/sdg10/ska10.a.png";
const sdg10b = "/images/pagethree_tr/sdg10/ska10.b.png";
const sdg10c = "/images/pagethree_tr/sdg10/ska10.c.png";
//  sdg11
const sdg111 = "/images/pagethree_tr/sdg11/ska11.1.png";
const sdg112 = "/images/pagethree_tr/sdg11/ska11.2.png";
const sdg113 = "/images/pagethree_tr/sdg11/ska11.3.png";
const sdg114 = "/images/pagethree_tr/sdg11/ska11.4.png";
const sdg115 = "/images/pagethree_tr/sdg11/ska11.5.png";
const sdg116 = "/images/pagethree_tr/sdg11/ska11.6.png";
const sdg117 = "/images/pagethree_tr/sdg11/ska11.7.png";
const sdg11a = "/images/pagethree_tr/sdg11/ska11.a.png";
const sdg11b = "/images/pagethree_tr/sdg11/ska11.b.png";
const sdg11c = "/images/pagethree_tr/sdg11/ska11.c.png";
//  sdg12
const sdg121 = "/images/pagethree_tr/sdg12/ska12.1.png";
const sdg122 = "/images/pagethree_tr/sdg12/ska12.2.png";
const sdg123 = "/images/pagethree_tr/sdg12/ska12.3.png";
const sdg124 = "/images/pagethree_tr/sdg12/ska12.4.png";
const sdg125 = "/images/pagethree_tr/sdg12/ska12.5.png";
const sdg126 = "/images/pagethree_tr/sdg12/ska12.6.png";
const sdg127 = "/images/pagethree_tr/sdg12/ska12.7.png";
const sdg128 = "/images/pagethree_tr/sdg12/ska12.8.png";
const sdg12a = "/images/pagethree_tr/sdg12/ska12.a.png";
const sdg12b = "/images/pagethree_tr/sdg12/ska12.b.png";
const sdg12c = "/images/pagethree_tr/sdg12/ska12.c.png";
//  sdg13
const sdg131 = "/images/pagethree_tr/sdg13/ska13.1.png";
const sdg132 = "/images/pagethree_tr/sdg13/ska13.2.png";
const sdg133 = "/images/pagethree_tr/sdg13/ska13.3.png";
const sdg13a = "/images/pagethree_tr/sdg13/ska13.a.png";
const sdg13b = "/images/pagethree_tr/sdg13/ska13.b.png";
//  sdg14
const sdg141 = "/images/pagethree_tr/sdg14/ska14.1.png";
const sdg142 = "/images/pagethree_tr/sdg14/ska14.2.png";
const sdg143 = "/images/pagethree_tr/sdg14/ska14.3.png";
const sdg144 = "/images/pagethree_tr/sdg14/ska14.4.png";
const sdg145 = "/images/pagethree_tr/sdg14/ska14.5.png";
const sdg146 = "/images/pagethree_tr/sdg14/ska14.6.png";
const sdg147 = "/images/pagethree_tr/sdg14/ska14.7.png";
const sdg14a = "/images/pagethree_tr/sdg14/ska14.a.png";
const sdg14b = "/images/pagethree_tr/sdg14/ska14.b.png";
const sdg14c = "/images/pagethree_tr/sdg14/ska14.c.png";
//  sdg15
const sdg151 = "/images/pagethree_tr/sdg15/ska15.1.png";
const sdg152 = "/images/pagethree_tr/sdg15/ska15.2.png";
const sdg153 = "/images/pagethree_tr/sdg15/ska15.3.png";
const sdg154 = "/images/pagethree_tr/sdg15/ska15.4.png";
const sdg155 = "/images/pagethree_tr/sdg15/ska15.5.png";
const sdg156 = "/images/pagethree_tr/sdg15/ska15.6.png";
const sdg157 = "/images/pagethree_tr/sdg15/ska15.7.png";
const sdg158 = "/images/pagethree_tr/sdg15/ska15.8.png";
const sdg159 = "/images/pagethree_tr/sdg15/ska15.9.png";
const sdg15a = "/images/pagethree_tr/sdg15/ska15.a.png";
const sdg15b = "/images/pagethree_tr/sdg15/ska15.b.png";
const sdg15c = "/images/pagethree_tr/sdg15/ska15.c.png";
//  sdg16
const sdg161 = "/images/pagethree_tr/sdg16/ska16.1.png";
const sdg162 = "/images/pagethree_tr/sdg16/ska16.2.png";
const sdg163 = "/images/pagethree_tr/sdg16/ska16.3.png";
const sdg164 = "/images/pagethree_tr/sdg16/ska16.4.png";
const sdg165 = "/images/pagethree_tr/sdg16/ska16.5.png";
const sdg166 = "/images/pagethree_tr/sdg16/ska16.6.png";
const sdg167 = "/images/pagethree_tr/sdg16/ska16.7.png";
const sdg168 = "/images/pagethree_tr/sdg16/ska16.8.png";
const sdg169 = "/images/pagethree_tr/sdg16/ska16.9.png";
const sdg1610 = "/images/pagethree_tr/sdg16/ska16.10.png";
const sdg16a = "/images/pagethree_tr/sdg16/ska16.a.png";
const sdg16b = "/images/pagethree_tr/sdg16/ska16.b.png";
//  sdg17
const sdg171 = "/images/pagethree_tr/sdg17/ska17.1.png";
const sdg172 = "/images/pagethree_tr/sdg17/ska17.2.png";
const sdg173 = "/images/pagethree_tr/sdg17/ska17.3.png";
const sdg174 = "/images/pagethree_tr/sdg17/ska17.4.png";
const sdg175 = "/images/pagethree_tr/sdg17/ska17.5.png";
const sdg176 = "/images/pagethree_tr/sdg17/ska17.6.png";
const sdg177 = "/images/pagethree_tr/sdg17/ska17.7.png";
const sdg178 = "/images/pagethree_tr/sdg17/ska17.8.png";
const sdg179 = "/images/pagethree_tr/sdg17/ska17.9.png";
const sdg1710 = "/images/pagethree_tr/sdg17/ska17.10.png";
const sdg1711 = "/images/pagethree_tr/sdg17/ska17.11.png";
const sdg1712 = "/images/pagethree_tr/sdg17/ska17.12.png";
const sdg1713 = "/images/pagethree_tr/sdg17/ska17.13.png";
const sdg1714 = "/images/pagethree_tr/sdg17/ska17.14.png";
const sdg1715 = "/images/pagethree_tr/sdg17/ska17.15.png";
const sdg1716 = "/images/pagethree_tr/sdg17/ska17.16.png";
const sdg1717 = "/images/pagethree_tr/sdg17/ska17.17.png";
const sdg1718 = "/images/pagethree_tr/sdg17/ska17.18.png";
const sdg1719 = "/images/pagethree_tr/sdg17/ska17.19.png";
//  step4
const step41 = "/images/pagefour_tr/1.png";
const step42 = "/images/pagefour_tr/2.png";
const step43 = "/images/pagefour_tr/3.png";
const step44 = "/images/pagefour_tr/4.png";
const step45 = "/images/pagefour_tr/5.png";
const step46 = "/images/pagefour_tr/6.png";
const step47 = "/images/pagefour_tr/7.png";
const step48 = "/images/pagefour_tr/8.png";

export default {
  components: {
    VueSelectImage,
  },
  data() {
    return {
      selectedImages: [],
      selectedImages3: [],
      selectedImages4: [],
      initialSelected: [],
      initialSelected3: [],
      initialSelected4: [],
      pageThreeImages: [],
      textQuestions: "",
      textQuestions2 : "",
      userCompanyId : "",
      sendStep2Photos : [],
      sendStep3Photos : [],
      sendStep4Photos : [],
      showThanks : false,
      showSurvey : false,
      questionsControl: true,
      responseMessage : "",
      dataImages: [
        {
          id: 1,
          src: image1,
          alt: "1",
        },
        {
          id: 2,
          src: image2,
          alt: "2",
        },
        {
          id: 3,
          src: image3,
          alt: "3",
        },
        {
          id: 4,
          src: image4,
          alt: "4",
        },
        {
          id: 5,
          src: image5,
          alt: "5",
        },
        {
          id: 6,
          src: image6,
          alt: "6",
        },
        {
          id: 7,
          src: image7,
          alt: "7",
        },
        {
          id: 8,
          src: image8,
          alt: "8",
        },
        {
          id: 9,
          src: image9,
          alt: "9",
        },
        {
          id: 10,
          src: image10,
          alt: "10",
        },
        {
          id: 11,
          src: image11,
          alt: "11",
        },
        {
          id: 12,
          src: image12,
          alt: "12",
        },
        {
          id: 13,
          src: image13,
          alt: "13",
        },
        {
          id: 14,
          src: image14,
          alt: "14",
        },
        {
          id: 15,
          src: image15,
          alt: "15",
        },
        {
          id: 16,
          src: image16,
          alt: "16",
        },
        {
          id: 17,
          src: image17,
          alt: "17",
        },
      ],
      sdg1: [
        {
          id: 11,
          src: sdg11,
          alt: "1",
        },
        {
          id: 12,
          src: sdg12,
          alt: "2",
        },
        {
          id: 13,
          src: sdg13,
          alt: "3",
        },
        {
          id: 14,
          src: sdg14,
          alt: "4",
        },
        {
          id: 15,
          src: sdg15,
          alt: "5",
        },
        {
          id: 16,
          src: sdg1a,
          alt: "6",
        },
        {
          id: 17,
          src: sdg1b,
          alt: "7",
        },
      ],
      sdg2: [
        {
          id: 21,
          src: sdg21,
          alt: "1",
        },
        {
          id: 22,
          src: sdg22,
          alt: "2",
        },
        {
          id: 23,
          src: sdg23,
          alt: "3",
        },
        {
          id: 24,
          src: sdg24,
          alt: "4",
        },
        {
          id: 25,
          src: sdg25,
          alt: "5",
        },
        {
          id: 26,
          src: sdg2a,
          alt: "6",
        },
        {
          id: 27,
          src: sdg2b,
          alt: "7",
        },
        {
          id: 28,
          src: sdg2c,
          alt: "8",
        },
      ],
      sdg3: [
        {
          id: 31,
          src: sdg31,
          alt: "1",
        },
        {
          id: 32,
          src: sdg32,
          alt: "2",
        },
        {
          id: 33,
          src: sdg33,
          alt: "3",
        },
        {
          id: 34,
          src: sdg34,
          alt: "4",
        },
        {
          id: 35,
          src: sdg35,
          alt: "5",
        },
        {
          id: 36,
          src: sdg36,
          alt: "6",
        },
        {
          id: 37,
          src: sdg37,
          alt: "7",
        },
        {
          id: 38,
          src: sdg38,
          alt: "8",
        },
        {
          id: 39,
          src: sdg39,
          alt: "9",
        }, // AAAAAAAAAAAAAAAAAAA //
        {
          id: 310,
          src: sdg3a,
          alt: "10",
        },
        {
          id: 311,
          src: sdg3b,
          alt: "11",
        },
        {
          id: 312,
          src: sdg3c,
          alt: "12",
        },
        {
          id: 313,
          src: sdg3d,
          alt: "12",
        },
      ],
      sdg4: [
        {
          id: 41,
          src: sdg41,
          alt: "1",
        },
        {
          id: 42,
          src: sdg42,
          alt: "2",
        },
        {
          id: 43,
          src: sdg43,
          alt: "3",
        },
        {
          id: 44,
          src: sdg44,
          alt: "4",
        },
        {
          id: 45,
          src: sdg45,
          alt: "5",
        },
        {
          id: 46,
          src: sdg46,
          alt: "6",
        },
        {
          id: 47,
          src: sdg47,
          alt: "7",
        },
        {
          id: 48,
          src: sdg4a,
          alt: "8",
        },
        {
          id: 49,
          src: sdg4b,
          alt: "9",
        }, // AAAAAAAAAAAAAAAAAAAAAAA //
        {
          id: 410,
          src: sdg4c,
          alt: "10",
        },
      ],
      sdg5: [
        {
          id: 51,
          src: sdg51,
          alt: "1",
        },
        {
          id: 52,
          src: sdg52,
          alt: "2",
        },
        {
          id: 53,
          src: sdg53,
          alt: "3",
        },
        {
          id: 54,
          src: sdg54,
          alt: "4",
        },
        {
          id: 55,
          src: sdg55,
          alt: "5",
        },
        {
          id: 56,
          src: sdg56,
          alt: "6",
        },
        {
          id: 57,
          src: sdg5a,
          alt: "7",
        },
        {
          id: 58,
          src: sdg5b,
          alt: "8",
        },
        {
          id: 59,
          src: sdg5c,
          alt: "9",
        },
      ],
      sdg6: [
        {
          id: 61,
          src: sdg61,
          alt: "1",
        },
        {
          id: 62,
          src: sdg62,
          alt: "2",
        },
        {
          id: 63,
          src: sdg63,
          alt: "3",
        },
        {
          id: 64,
          src: sdg64,
          alt: "4",
        },
        {
          id: 65,
          src: sdg65,
          alt: "5",
        },
        {
          id: 66,
          src: sdg66,
          alt: "6",
        },
        {
          id: 67,
          src: sdg6a,
          alt: "7",
        },
        {
          id: 68,
          src: sdg6b,
          alt: "8",
        },
      ],
      sdg7: [
        {
          id: 71,
          src: sdg71,
          alt: "1",
        },
        {
          id: 72,
          src: sdg72,
          alt: "2",
        },
        {
          id: 73,
          src: sdg73,
          alt: "3",
        },
        {
          id: 74,
          src: sdg7a,
          alt: "4",
        },
        {
          id: 75,
          src: sdg7b,
          alt: "5",
        },
      ],
      sdg8: [
        {
          id: 81,
          src: sdg81,
          alt: "1",
        },
        {
          id: 82,
          src: sdg82,
          alt: "2",
        },
        {
          id: 83,
          src: sdg83,
          alt: "3",
        },
        {
          id: 84,
          src: sdg84,
          alt: "4",
        },
        {
          id: 85,
          src: sdg85,
          alt: "5",
        },
        {
          id: 86,
          src: sdg86,
          alt: "6",
        },
        {
          id: 87,
          src: sdg87,
          alt: "7",
        },
        {
          id: 88,
          src: sdg88,
          alt: "8",
        },
        {
          id: 89,
          src: sdg89,
          alt: "9",
        },
        {
          id: 810, // AAAAAAAAAAAAAAAAAAA //
          src: sdg810,
          alt: "10",
        },
        {
          id: 811,
          src: sdg8a,
          alt: "11",
        },
        {
          id: 812,
          src: sdg8b,
          alt: "12",
        },
      ],
      sdg9: [
        {
          id: 91,
          src: sdg91,
          alt: "1",
        },
        {
          id: 92,
          src: sdg92,
          alt: "2",
        },
        {
          id: 93,
          src: sdg93,
          alt: "3",
        },
        {
          id: 94,
          src: sdg94,
          alt: "4",
        },
        {
          id: 95,
          src: sdg95,
          alt: "5",
        },
        {
          id: 96,
          src: sdg9a,
          alt: "6",
        },
        {
          id: 97,
          src: sdg9b,
          alt: "7",
        },
        {
          id: 98,
          src: sdg9c,
          alt: "8",
        },
      ],
      sdg10: [
        {
          id: 101,
          src: sdg101,
          alt: "1",
        },
        {
          id: 102,
          src: sdg102,
          alt: "2",
        },
        {
          id: 103,
          src: sdg103,
          alt: "3",
        },
        {
          id: 104,
          src: sdg104,
          alt: "4",
        },
        {
          id: 105,
          src: sdg105,
          alt: "5",
        },
        {
          id: 106,
          src: sdg106,
          alt: "6",
        },
        {
          id: 107,
          src: sdg107,
          alt: "7",
        },
        {
          id: 108,
          src: sdg10a,
          alt: "8",
        },
        {
          id: 109,
          src: sdg10b,
          alt: "9",
        },
        {
          id: 1010, // AAAAAAAAAAAAAAAAAAA //
          src: sdg10c,
          alt: "10",
        },
      ],
      sdg11: [
        {
          id: 111,
          src: sdg111,
          alt: "1",
        },
        {
          id: 112,
          src: sdg112,
          alt: "2",
        },
        {
          id: 113,
          src: sdg113,
          alt: "3",
        },
        {
          id: 114,
          src: sdg114,
          alt: "4",
        },
        {
          id: 115,
          src: sdg115,
          alt: "5",
        },
        {
          id: 116,
          src: sdg116,
          alt: "6",
        },
        {
          id: 117,
          src: sdg117,
          alt: "7",
        },
        {
          id: 118,
          src: sdg11a,
          alt: "8",
        },
        {
          id: 119,
          src: sdg11b,
          alt: "9",
        },
        {
          id: 1110, // AAAAAAAAAAAAAAAAAAA //
          src: sdg11c,
          alt: "10",
        },
      ],
      sdg12: [
        {
          id: 121,
          src: sdg121,
          alt: "1",
        },
        {
          id: 122,
          src: sdg122,
          alt: "2",
        },
        {
          id: 123,
          src: sdg123,
          alt: "3",
        },
        {
          id: 124,
          src: sdg124,
          alt: "4",
        },
        {
          id: 125,
          src: sdg125,
          alt: "5",
        },
        {
          id: 126,
          src: sdg126,
          alt: "6",
        },
        {
          id: 127,
          src: sdg127,
          alt: "7",
        },
        {
          id: 128,
          src: sdg128,
          alt: "8",
        },
        {
          id: 129,
          src: sdg12a,
          alt: "9",
        },
        {
          id: 1210, // AAAAAAAAAAAAAAAAAAA //
          src: sdg12b,
          alt: "10",
        },
        {
          id: 1211,
          src: sdg12c,
          alt: "11",
        },
      ],
      sdg13: [
        {
          id: 131,
          src: sdg131,
          alt: "1",
        },
        {
          id: 132,
          src: sdg132,
          alt: "2",
        },
        {
          id: 133,
          src: sdg133,
          alt: "3",
        },
        {
          id: 134,
          src: sdg13a,
          alt: "4",
        },
        {
          id: 135,
          src: sdg13b,
          alt: "5",
        },
      ],
      sdg14: [
        {
          id: 141,
          src: sdg141,
          alt: "1",
        },
        {
          id: 142,
          src: sdg142,
          alt: "2",
        },
        {
          id: 143,
          src: sdg143,
          alt: "3",
        },
        {
          id: 144,
          src: sdg144,
          alt: "4",
        },
        {
          id: 145,
          src: sdg145,
          alt: "5",
        },
        {
          id: 146,
          src: sdg146,
          alt: "6",
        },
        {
          id: 147,
          src: sdg147,
          alt: "7",
        },
        {
          id: 148,
          src: sdg14a,
          alt: "8",
        },
        {
          id: 149,
          src: sdg14b,
          alt: "9",
        },
        {
          id: 1410, // AAAAAAAAAAAAAAAAAAA //
          src: sdg14c,
          alt: "10",
        },
      ],
      sdg15: [
        {
          id: 151,
          src: sdg151,
          alt: "1",
        },
        {
          id: 152,
          src: sdg152,
          alt: "2",
        },
        {
          id: 153,
          src: sdg153,
          alt: "3",
        },
        {
          id: 154,
          src: sdg154,
          alt: "4",
        },
        {
          id: 155,
          src: sdg155,
          alt: "5",
        },
        {
          id: 156,
          src: sdg156,
          alt: "6",
        },
        {
          id: 157,
          src: sdg157,
          alt: "7",
        },
        {
          id: 158,
          src: sdg158,
          alt: "8",
        },
        {
          id: 159,
          src: sdg159,
          alt: "9",
        },
        {
          id: 1510, // AAAAAAAAAAAAAAAAAAA //
          src: sdg15a,
          alt: "10",
        },
        {
          id: 1511,
          src: sdg15b,
          alt: "11",
        },
        {
          id: 1512,
          src: sdg15c,
          alt: "12",
        },
      ],
      sdg16: [
        {
          id: 161,
          src: sdg161,
          alt: "1",
        },
        {
          id: 162,
          src: sdg162,
          alt: "2",
        },
        {
          id: 163,
          src: sdg163,
          alt: "3",
        },
        {
          id: 164,
          src: sdg164,
          alt: "4",
        },
        {
          id: 165,
          src: sdg165,
          alt: "5",
        },
        {
          id: 166,
          src: sdg166,
          alt: "6",
        },
        {
          id: 167,
          src: sdg167,
          alt: "7",
        },
        {
          id: 168,
          src: sdg168,
          alt: "8",
        },
        {
          id: 169,
          src: sdg169,
          alt: "9",
        },
        {
          id: 1610, // AAAAAAAAAAAAAAAAAAA //
          src: sdg1610,
          alt: "10",
        },
        {
          id: 1611,
          src: sdg16a,
          alt: "11",
        },
        {
          id: 1612,
          src: sdg16b,
          alt: "12",
        },
      ],
      sdg17: [
        {
          id: 171,
          src: sdg171,
          alt: "1",
        },
        {
          id: 172,
          src: sdg172,
          alt: "2",
        },
        {
          id: 173,
          src: sdg173,
          alt: "3",
        },
        {
          id: 174,
          src: sdg174,
          alt: "4",
        },
        {
          id: 175,
          src: sdg175,
          alt: "5",
        },
        {
          id: 176,
          src: sdg176,
          alt: "6",
        },
        {
          id: 177,
          src: sdg177,
          alt: "7",
        },
        {
          id: 178,
          src: sdg178,
          alt: "8",
        },
        {
          id: 179,
          src: sdg179,
          alt: "9",
        },
        {
          id: 1710, // AAAAAAAAAAAAAAAAAAA //
          src: sdg1710,
          alt: "10",
        },
        {
          id: 1711,
          src: sdg1711,
          alt: "11",
        },
        {
          id: 1712,
          src: sdg1712,
          alt: "12",
        },
        {
          id: 1713,
          src: sdg1713,
          alt: "13",
        },
        {
          id: 1714,
          src: sdg1714,
          alt: "14",
        },
        {
          id: 1715,
          src: sdg1715,
          alt: "15",
        },
        {
          id: 1716,
          src: sdg1716,
          alt: "16",
        },
        {
          id: 1717,
          src: sdg1717,
          alt: "17",
        },
        {
          id: 1718,
          src: sdg1718,
          alt: "18",
        },
        {
          id: 1719,
          src: sdg1719,
          alt: "19",
        },
      ],
      step4: [
        {
          id: 181,
          src: step41,
          alt: "1",
        },
        {
          id: 182,
          src: step42,
          alt: "2",
        },
        {
          id: 183,
          src: step43,
          alt: "3",
        },
        {
          id: 184,
          src: step44,
          alt: "4",
        },
        {
          id: 185,
          src: step45,
          alt: "5",
        },
        {
          id: 186,
          src: step46,
          alt: "6",
        },
        {
          id: 187,
          src: step47,
          alt: "7",
        },
        {
          id: 188,
          src: step48,
          alt: "8",
        },
      ],
      companyName : "",
      name : "",
      surname : "",
      email : "",
      department: "",
      id : "",
      surveyName : "",
      surveyId : "",
      step2Control : false
    };
  },
  mounted(){
    this.getSurveys();
    this.userInfo();
  },
  methods: {
    ...mapActions("surveys", [
      "su1CreateResults",
      "getUserTokenSU1",
      "postUserInfo",
    ]),
    userInfo() {
      this.showSurvey = true;//This was assigned as false, changed it to true because page wouldn't load if it is false.
      let params = {
        user_id: this.$route.query.user,
      };
      this.postUserInfo(params)
        .then((res) => {
          this.name = res.data[0].firstname;
          this.surname = res.data[0].surname;
          this.email = res.data[0].email;
          this.userCompanyId = res.data[0].company_id;
          this.department = res.data[0].user_department_name;
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
    getSurveys() {
      let params = {
        token: this.$route.query.token,
        user: this.$route.query.user,
        id: this.$route.query.id,
      };
      this.getUserTokenSU1(params)
        .then((res) => {
          this.companyName = res.data[0].company_name;
          this.surveyName = res.data[0].su1_survey_name;
          this.surveyId = res.data[0].su1_survey_id;
        })
        .catch(({ response }) => {
          this.responseMessage = this.$parseResMessage(response.data.messageName);
          this.questionsControl = true;
          this.showSurvey = false;
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
    createSurveyPost() {
      const params = {
        su1_survey_id : this.surveyId,
        company_id : this.userCompanyId,
        completed_by : this.$route.query.user,
        su1_global_goals_answer : this.sendStep2Photos,
        su1_sub_goals_answer : this.sendStep3Photos,
        su1_green_deals_answer : this.sendStep4Photos,
        su1_texts_answer_1 : this.textQuestions,
        su1_texts_answer_2 : this.textQuestions2
      };

      if (this.canPostSurvey) {
        this.su1CreateResults(params)
          .then((res) => {
            this.showThanks = true;
            this.questionsControl = true;
            this.showSurvey = false;
            this.$toast.open({
              message: this.$parseResMessage(res.data.messageName),
              type: "success",
              duration: 5000,
              dismissible: true,
            });
          })
          .catch(({ response }) => {
            this.$toast.open({
              message: this.$parseResMessage(response.data.messageName),
              type: "error",
              duration: 5000,
              dismissible: true,
            });
          })
          .finally(() => {});
      } else {
        this.$toast.open({
          message: "Select at least one image for each step!",
          type: "error",
          duration: 5000,
          dismissible: true,
        });
      }
    },

    onSelectMultipleImage(data) {
      this.pageThreeImages = [];
      this.selectedImages = data;
      let selected1 = this.selectedImages.filter(function (item) {
        return item.id == 1;
      });
      let selected2 = this.selectedImages.filter(function (item) {
        return item.id == 2;
      });
      let selected3 = this.selectedImages.filter(function (item) {
        return item.id == 3;
      });
      let selected4 = this.selectedImages.filter(function (item) {
        return item.id == 4;
      });
      let selected5 = this.selectedImages.filter(function (item) {
        return item.id == 5;
      });
      let selected6 = this.selectedImages.filter(function (item) {
        return item.id == 6;
      });
      let selected7 = this.selectedImages.filter(function (item) {
        return item.id == 7;
      });
      let selected8 = this.selectedImages.filter(function (item) {
        return item.id == 8;
      });
      let selected9 = this.selectedImages.filter(function (item) {
        return item.id == 9;
      });
      let selected10 = this.selectedImages.filter(function (item) {
        return item.id == 10;
      });
      let selected11 = this.selectedImages.filter(function (item) {
        return item.id == 11;
      });
      let selected12 = this.selectedImages.filter(function (item) {
        return item.id == 12;
      });
      let selected13 = this.selectedImages.filter(function (item) {
        return item.id == 13;
      });
      let selected14 = this.selectedImages.filter(function (item) {
        return item.id == 14;
      });
      let selected15 = this.selectedImages.filter(function (item) {
        return item.id == 15;
      });
      let selected16 = this.selectedImages.filter(function (item) {
        return item.id == 16;
      });
      let selected17 = this.selectedImages.filter(function (item) {
        return item.id == 17;
      });

      if (selected1.length !== 0) {
        this.sdg1.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected2.length !== 0) {
        this.sdg2.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected3.length !== 0) {
        this.sdg3.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected4.length !== 0) {
        this.sdg4.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected5.length !== 0) {
        this.sdg5.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected6.length !== 0) {
        this.sdg6.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected7.length !== 0) {
        this.sdg7.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected8.length !== 0) {
        this.sdg8.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected9.length !== 0) {
        this.sdg9.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected10.length !== 0) {
        this.sdg10.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected11.length !== 0) {
        this.sdg11.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected12.length !== 0) {
        this.sdg12.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected13.length !== 0) {
        this.sdg13.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected14.length !== 0) {
        this.sdg14.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected15.length !== 0) {
        this.sdg15.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected16.length !== 0) {
        this.sdg16.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
      if (selected17.length !== 0) {
        this.sdg17.forEach((element) => {
          this.pageThreeImages.push(element);
        });
      }
    },
    onSelectMultipleImage3(data) {
      this.selectedImages3 = data;
    },
    onSelectMultipleImage4(data) {
      this.selectedImages4 = data;
    },
  },
  watch: {
    selectedImages(){
      this.sendStep2Photos = []
      this.selectedImages.forEach((element) => {
        this.sendStep2Photos.push(element.id)
      })
    },
    selectedImages3(){
      this.sendStep3Photos = []
      this.selectedImages3.forEach((element) => {
        this.sendStep3Photos.push(element.id)
      })
    },
    selectedImages4(){
      this.sendStep4Photos = []
      this.selectedImages4.forEach((element) => {
        this.sendStep4Photos.push(element.id)
      })
    },
  },

  computed: {
    canPostSurvey() {
      return (this.sendStep2Photos.length > 0 && this.sendStep3Photos.length > 0 && this.sendStep4Photos.length > 0);
    }
  }
};
</script>

<template>
  <div class="flex-all-centered-col" style="overflow: auto; justify-content: flex-start; background-color: #eeeeee; height: 100vh;">
    <div v-if="questionsControl">
      <div>
        <h1>{{responseMessage}}</h1>
      </div>
    </div> 

    <div v-show="showSurvey" class="flex-all-centered-col">
      <div class="flex-all-centered-row">
        <a
          class="navbar-brand"
          href="https://www.sustainfinity.com/"
          target="_blank"
          ><img style="height:100px;width:110px" src="/images/sustainfinity_512x512.png" alt="sustainfinity-logo"
        /></a>
        <div>
          {{ surveyName }}
        </div>
      </div>

      <br />

      <div style="max-width: 60%">
        <h3 class="su1-h3">Bu anket, Sustainfinity Platformu aracılığıyla {{ companyName }} adına hazırlanmıştır.</h3>
        <br />
        <div>
          <div style="text-align: center">
            <div class="worko-tabs">
              <input
                class="state"
                type="radio"
                title="tab-one"
                name="tabs-state"
                id="tab-one"
                checked
                active
              />
              <input
                class="state"
                type="radio"
                title="tab-two"
                name="tabs-state"
                id="tab-two"
              />
              <input
                class="state"
                type="radio"
                title="tab-three"
                name="tabs-state"
                id="tab-three"
              />
              <input
                class="state"
                type="radio"
                title="tab-four"
                name="tabs-state"
                id="tab-four"
              />
              <input
                class="state"
                type="radio"
                title="tab-five"
                name="tabs-state"
                id="tab-five"
              />

              <div class="tabs flex-tabs">
                <label for="tab-one" id="tab-one-label" class="tab"
                  >Adım 1</label
                >
                <label for="tab-two" id="tab-two-label" class="tab"
                  >Adım 2</label
                >
                <label for="tab-three" id="tab-three-label" class="tab"
                  >Adım 3</label
                >
                <label for="tab-four" id="tab-four-label" class="tab"
                  >Adım 4</label
                >
                <label for="tab-five" id="tab-five-label" class="tab"
                  >Adım 5</label
                >

                <div id="tab-one-panel" class="panel active">
                  <h5 style="color: #7f7f7f;">
                    Değerli Paydaşımız {{name}} {{surname}},
                  </h5>
                  
                  <h5 style="color: #7f7f7f;">
                    Sürdürülebilirlik işletmemiz için büyük bir öneme sahiptir ve bu konudaki düşünceleriniz bizim için son derece değerlidir. 
                    Bu nedenle, sürdürülebilirlik hedeflerimizi daha iyi anlamamıza ve sizinle daha etkili bir iş birliği 
                    yapmamıza yardımcı olacak anketimize katılmanızı istemekteyiz.
                  </h5>

                  <h5 style="color: #7f7f7f;">
                    Bu anketin ilk bölümü, iş faaliyetlerimizi Birleşmiş Milletler Sürdürülebilir Kalkınma Amaçları (SKA) ile uyumlu hale getirmeyi amaçlamaktadır. 
                    İlk soruda, iş faaliyetlerimizle en ilgili SKA’ları, SKA logolarına tıklayarak seçebilirsiniz. 
                    Bunu takiben, ikinci soruda bu SKA’ların hangi Alt Hedeflerinin işimiz tarafından desteklenebileceğini belirlemek için ikinci bir soru bulunmaktadır. 
                    SKA’larla ilgili detaylı bilgilere  
                    <a href="https://www.kureselamaclar.org/" style="text-decoration: underline; color: #46626f;">
                      https://www.kureselamaclar.org/
                    </a> 
                    resmî web sitesinden ulaşabilirsiniz.
                  </h5>

                  <h5 style="color: #7f7f7f;">
                    Üçüncü soru, Avrupa Yeşil Mutabakatı hedeflerine nasıl katkıda bulunabileceğimizi değerlendirmeyi amaçlamaktadır. 
                    İşimiz için hangi hedeflerin önemli olduğunu sizin bakış açınızdan duymak isteriz.
                  </h5>

                  <h5 style="color: #7f7f7f;">
                    Anketin son bölümünde ise iki açık uçlu soru bulunmaktadır. 
                    Bu sorular, sürdürülebilirlik konusundaki kişisel bakış açınız ve biriminizde başlattığınız sürdürülebilirlik projeleri hakkında bilgi istemektedir.
                  </h5>

                  <h5 style="color: #7f7f7f;">
                    Düşüncelerinizi duymaktan heyecan duyuyoruz ve sürdürülebilir bir geleceğe birlikte yürüdüğümüz için size minnettarız.
                  </h5>

                  <h5 style="color: #7f7f7f;">
                    Saygılarımızla,
                  </h5>

                  <h5 style="color: #7f7f7f;">
                    {{companyName}}
                  </h5>
                  <br /><br />

                  <div>
                    <div style="margin: auto; max-width: 70%;">
                      <div style="color: #7f7f7f;">
                        <div
                          class="flex-all-centered-row"
                          style="font-size: 20px; border-top-right-radius: 30px; border-top-left-radius: 30px; justify-content: space-between; border-bottom: medium solid #828282;"
                        >
                          <b>İsim-Soyisim</b>
                          <span pill>{{ name }} {{ surname }}</span>
                        </div>

                        <div
                          class="flex-all-centered-row"
                          style="font-size: 20px; border-bottom: medium solid #828282; justify-content: space-between"
                        >
                          <b>E-mail</b>
                          <span pill>{{ email }}</span>
                        </div>
                        <div
                          class="flex-all-centered-row"
                          style="font-size: 20px; border-bottom: medium solid #828282; justify-content: space-between"
                        >
                          <b>Birim</b>
                          <span pill>{{ department }}</span>
                        </div>
                        <div
                          class="flex-all-centered-row"
                          style="font-size: 20px;  border-bottom-right-radius: 30px; justify-content: space-between; border-bottom-left-radius: 30px;"
                        >
                          <b>Şirket İsmi</b>
                          <span pill>{{ companyName }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row justify-content">
                    <div class="col-12">
                      <label
                        id="tab-two-label"
                        for="tab-two"
                        class="pointer btn btn-success btn-block mySurveyGreenButton"
                        style="float: right; width: 100px; display: block"
                      >
                        {{ $t('su1.steps.step2') }}
                      </label>
                    </div>

                  </div>
                </div>

                <div id="tab-two-panel" class="panel">
                  <h6>Biriminizdeki görevleri, sorumlulukları, faaliyetleri ve planlanan projeleri düşündüğünüzde,</h6>
                  <h6>Lütfen aşağıdaki 17 Küresel Amaç’tan (SKA’dan) biriminizin doğrudan ilgili olduğunu düşündüklerinizi seçmek için logoların üzerlerine tıklayın. (En az 1 öğe seçin)</h6>
                  <br /><br />

                  <vue-select-image
                  :rootClass="'custom-style'"
                    :dataImages="dataImages"
                    :is-multiple="true"
                    :selectedImages="initialSelected"
                    @onselectmultipleimage="onSelectMultipleImage"
                    :w="width"
                    :h="height"
                    :active-class="test"
                  >
                  </vue-select-image>
                  <div class="row justify-content">
                    <div class="col-12">
                      <label
                        for="tab-three"
                        id="tab-three-label"
                        class="pointer"
                        style="float: right; display: contents"
                      >
                        <b-button
                          style="width: 100px; float: right; display: block"
                          class="btn btn-success btn-block mySurveyGreenButton"
                          @click="stepControl()"
                        >{{ $t("su1.steps.step3") }}
                        </b-button>
                      </label>
                    </div>
                  </div>
                </div>
                <div id="tab-three-panel" class="panel">
                  <h6>Lütfen önceki seçiminize göre belirlenen aşağıdaki SKA Alt Hedefleri arasında,</h6>
                  <h6>Biriminizin ilişkili olduğu SKA Alt Hedeflerini seçmek için logoların üzerlerine tıklayın. (En az 1 öğe seçin.)</h6>
                  <br /><br />

                  <vue-select-image
                  :rootClass="'custom-style2'"

                    :dataImages="pageThreeImages"
                    :is-multiple="true"
                    :selectedImages="initialSelected3"
                    @onselectmultipleimage="onSelectMultipleImage3"
                    :weight="width"
                    :height="height"
                  >
                  </vue-select-image>
                  <div class="row justify-content">
                    <div class="col-12">
                      <label
                        for="tab-four"
                        id="tab-four-label"
                        class="pointer"
                        style="float: right; display: contents"
                      >
                      <b-button
                          style="width: 100px; float: right; display: block"
                          class="btn btn-success btn-block mySurveyGreenButton"
                          @click="stepControl()"
                        >{{ $t("su1.steps.step4") }}
                        </b-button>
                      </label>
                    </div>
                  </div>
                </div>
                <div id="tab-four-panel" class="panel">
                  <h6>Biriminizdeki görevleri, sorumlulukları, faaliyetleri ve planlanan projeleri düşündüğünüzde,</h6>
                  <h6>Lütfen aşağıdaki Avrupa Yeşil Mutabakat Hedefleri arasından biriminizin doğrudan ilişkili olduğunu düşündüklerinizi seçmek için logoların üzerlerine tıklayın. (En az 1 öğe seçin.)</h6>
                  <br /><br />
                  <vue-select-image
                  :rootClass="'custom-style'"
                    :dataImages="step4"
                    :is-multiple="true"
                    :selectedImages="initialSelected4"
                    @onselectmultipleimage="onSelectMultipleImage4"
                    :w="width"
                    :h="height"
                  >
                  </vue-select-image>
                  <div class="row justify-content">
                    <div class="col-12">
                      <label
                        for="tab-five"
                        id="tab-five-label"
                        class="pointer"
                        style="float: right; display: contents"
                      >
                      <b-button
                          style="width: 100px; float: right; display: block"
                          class="btn btn-success btn-block mySurveyGreenButton"
                          @click="stepControl()"
                        >{{ $t("su1.steps.step5") }}
                        </b-button>
                      </label>
                    </div>
                  </div>
                </div>
                <div id="tab-five-panel" class="panel">
                  <b-row class="mt-12">
                    <b-col sm="12">
                      <label style="text-align: center; font-size: 20px" for="textarea-default">
                        Sürdürülebilirlik kavramını kendi kelimelerinizle nasıl tanımlarsınız? 
                        <br>
                        Lütfen sürdürülebilirlik kavramının sizin için ne ifade ettiğini açıklayınız.
                      </label>
                    </b-col>
                    <b-col sm="12">
                      <b-form-textarea
                        id="textarea-default"
                        placeholder="Your answer..."
                        v-model="textQuestions"
                        rows="5"
                        style="border-radius: 20px;"
                      ></b-form-textarea>
                    </b-col>
                  </b-row>
                  <br />

                  <b-row class="mt-12">
                    <b-col sm="12">
                      <label style="text-align: center; font-size: 20px" for="textarea-default1">
                        Biriminizde gerçekleştirdiğiniz sürdürülebilirlik projelerinden bir veya birkaçını paylaşarak, <br>
                        Lütfen işletmemizin sürdürülebilirlik hedeflerine nasıl katkıda bulunmaya çalıştığınızı açıklayınız.
                      </label>
                    </b-col>
                    <b-col sm="12">
                      <b-form-textarea
                        id="textarea-default1"
                        placeholder="Your answer..."
                        v-model="textQuestions2"
                        rows="5"
                        style="border-radius: 20px;"
                      ></b-form-textarea>
                    </b-col>
                  </b-row>
                  <br />

                  <div class="row justify-content">
                    <div class="col-12">

                        <b-button
                          :disabled="!canPostSurvey"
                          style="width: 100px; float: right; display: block"
                          class="btn btn-success btn-block mySurveyGreenButton"
                          @click="createSurveyPost()"
                        >{{ $t("su1.steps.finish") }}
                        </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
    <div class="bgimg" style="height: 100%;">

      <div class="middle survey-end-text" v-show="showThanks" 
        style="color: #44a900; font-weight: 400; height: 100vh;"
      >
        <h1 style="font-weight: 400;">TEŞEKKÜR EDERİZ...</h1>
        <hr>
        <h1 style="font-weight: 400;">ANKET BAŞARIYLA TAMAMLANDI</h1>
        <p>Katılımınız için teşekkür ederiz</p>
        <hr>
        <footer>BU PENCEREYİ KAPATABİLİRSİNİZ</footer>
      </div>

    </div>
  </div>
</template>

<style lang="scss">

@media (max-width: 767px) {
  h1 {
    font-size: 38px;
  }
}

.survey-end-text{
  font-family: 'Courier New', Courier, monospace !important;
}
h1 {
  font-size: 28px ;
  line-height: 28px;
  margin-bottom: 15px;
}

h3, .h3 {
  font-size: 1.825em !important;
  line-height: 1.4 !important;
  margin: 20px 0 10px !important;
  font-style: normal !important;
  text-align: center !important;
}

.su1-h3{
  color: #023047 !important;
  font-size: 1.825em !important;
  line-height: 1.4 !important;
  margin: 20px 0 10px !important;
  font-style: normal !important;
  text-align: center !important;
}

.worko-tabs {
  width: 100%;

  .state {
    position: absolute;
    left: -10000px;
  }

  .flex-tabs {
    display: flex;
    justify-content:center;
    flex-wrap: wrap;

    

    .tab {
      flex-grow: 1;
    }

    .panel {
      background-color: #eee;
      padding: 20px;
      display: none;
      width: 100%;
      flex-basis: auto;
      border: .2em solid var(--sustainfinity-navy);
    }
  }

  .tab {
    display: inline-block;
    margin: 5px;
    max-width: 150px;
    vertical-align: top;
    background-color: #023047;
    color: white;
    cursor: hand;
    cursor: pointer;
    border: medium solid #023047;
    border-radius: 25px;

    &:hover {
      background-color: #fff;
      color: #023047;
    }
  }
}

#tab-one:checked ~ .tabs #tab-one-label,
#tab-two:checked ~ .tabs #tab-two-label,
#tab-three:checked ~ .tabs #tab-three-label,
#tab-four:checked ~ .tabs #tab-four-label,
#tab-five:checked ~ .tabs #tab-five-label {
  background-color: #fff;
  cursor: default;
  color: #023047;
}

#tab-one:checked ~ .tabs #tab-one-panel,
#tab-two:checked ~ .tabs #tab-two-panel,
#tab-three:checked ~ .tabs #tab-three-panel,
#tab-four:checked ~ .tabs #tab-four-panel,
#tab-five:checked ~ .tabs #tab-five-panel {
  display: block;
}

@media (max-width: 600px) {
  .flex-tabs {
    flex-direction: row;
    .tab {
      max-width: 80px;
    }
  }
}

.mySurveyGreenButton{
  border-radius: 25px !important;
  padding: 3px !important;
}

.disable {
  pointer-events: fill;
}

label {
  position: relative;
}

label:after {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  background: transparent;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.test {

  filter: grayscale(0);


}
.pointer {
  cursor: pointer;
}

//photo
.img-checkbox {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 240px;
    height: 225px;
  margin: 20px;
  padding: 0;
  border: 0.1rem solid var(--p-border-subdued, #dfe3e8);
  background: var(--p-surface, #f4f6f8);
  border-radius: 6px;
}

.img-checkbox-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-flow: column nowrap;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  opacity: 0;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 5px;
  cursor: pointer;
  -webkit-transition: all 0.6s ease-in-out 0s;
  -moz-transition: all 0.6s ease-in-out 0s;
  transition: all 0.6s ease-in-out 0s;
}

.img-checkbox:hover .img-checkbox-overlay {
  opacity: 1;
}

.img-checkbox-overlay-active {
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  opacity: 1;
  border-radius: 5px;
}

.img-checkbox-details {
  position: absolute;
  width: 100%;
  top: 0.8rem;
  left: 0.8rem;
  opacity: 0;
  -webkit-transition: all 0.6s ease-in-out 0s;
  -moz-transition: all 0.6s ease-in-out 0s;
  transition: all 0.6s ease-in-out 0s;
}

.img-checkbox:hover .img-checkbox-details,
.img-checkbox-active {
  opacity: 1;
}

.img-checkbox-image {
  max-width: 100%;
  max-height: 100%;
}

.img-checkbox-cb {
  /* Double-sized Checkboxes */
  -ms-transform: scale(2);
  /* IE */
  -moz-transform: scale(2);
  /* FF */
  -webkit-transform: scale(2);
  /* Safari and Chrome */
  -o-transform: scale(2);
  /* Opera */
  transform: scale(2);
  padding: 10px;
}

.img-checkbox-cb:hover {
  cursor: pointer;
}

.custom-style {
  display: flex;
  justify-content: center;
  &__wrapper {
    overflow: auto;
    list-style-image: none;
    list-style-position: outside;
    list-style-type: none;
    padding: 0;
    margin: 0
  }
  &__item {
    margin: 0px 12px 12px 0px;
    float: left;
    @media only screen and (min-width: 1200px) {
      margin-left: 30px;
    }
  }
  &__thumbnail{
    cursor: pointer;
    padding: 6px;
    display: block;
    padding: 4px;
    line-height: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .055);
    transition: all .2s ease-in-out;
    &--selected{
      background: #61a60e;
      .custom-style__img{
        filter: grayscale(0);
      }
    }
  }
  &__img{
    -webkit-user-drag: none;
    display: block;
    width: 200px;
    height: 200px;
    margin-right: auto;
    margin-left: auto;
    transition: transform 0.25s;
    filter: grayscale(100%);
  }
  &__img2{
    -webkit-user-drag: none;
    display: block;
    width: 200px;
    height: 292px;
    margin-right: auto;
    margin-left: auto;
    transition: transform 0.25s;
    filter: grayscale(100%);
  }
}

.custom-style2 {
  display: flex;
  justify-content: center;
  &__wrapper {
    overflow: auto;
    list-style-image: none;
    list-style-position: outside;
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  &__item {
    margin: 0px 12px 12px 0px;
    float: left;
    @media only screen and (min-width: 1200px) {
      margin-left: 30px;
    }
  }
  &__thumbnail{
    cursor: pointer;
    padding: 6px;
    display: block;
    padding: 4px;
    line-height: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .055);
    transition: all .2s ease-in-out;
    &--selected{
      background: #61a60e;
      .custom-style2__img{
        filter: grayscale(0);
      }
    }
  }
  &__img{
    -webkit-user-drag: none;
    display: block;
    width: 300px;
    height: 200px;
    margin-right: auto;
    margin-left: auto;
    transition: transform 0.25s;
    filter: grayscale(100%);
  }
}

.custom-style3 {
  display: flex;
  justify-content: center;
  &__wrapper {
    overflow: auto;
    list-style-image: none;
    list-style-position: outside;
    list-style-type: none;
    padding: 0;
    margin: 0
  }
  &__item {
    margin: 0px 12px 12px 0px;
    float: left;
    @media only screen and (min-width: 1200px) {
      margin-left: 30px;
    }
  }
  &__thumbnail{
    cursor: pointer;
    padding: 6px;
    display: block;
    padding: 4px;
    line-height: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .055);
    transition: all .2s ease-in-out;
    &--selected{
      background: #61a60e;
      .custom-style2__img{
        filter: grayscale(0);
      }
    }
  }
  &__img{
    -webkit-user-drag: none;
    display: block;
    width: 180px;
    height: 250px;
    margin-right: auto;
    margin-left: auto;
    transition: transform 0.25s;

  }
}
</style>

